export default __webpack_public_path__ + "static/media/userBlob.414063b1.png";